/*
  clikt. — smooth open/close for every accordion on the site.

  FAQ, the product collapsible tabs, the collapsible-content section — all of
  them are <details> with a single content panel (.clikt-faq__a or
  .accordion__content). This eases that panel's height open and shut with the
  same slow, soft curve as the product spec sections, instead of the native
  snap.

  It only touches <details> that carry one of those content classes, so the
  header menus, cart drawer, search and facets — which are also <details> —
  are left completely alone. Reduced-motion users get an instant toggle.
*/
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CURVE = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var EASE = 'height 0.42s ' + CURVE + ', padding-top 0.42s ' + CURVE + ', padding-bottom 0.42s ' + CURVE + ', opacity 0.3s ease';
  var PANEL = ':scope > .clikt-faq__a, :scope > .accordion__content';

  function panelOf(details) {
    return details.querySelector(PANEL);
  }

  function clear(panel) {
    panel.style.height = panel.style.paddingTop = panel.style.paddingBottom =
      panel.style.transition = panel.style.overflow = panel.style.opacity = '';
  }

  /*
    The panel has its own padding, so a height of 0 still leaves that padding
    showing — which is the jolt at the ends of the open and close. So we ease
    the padding down to 0 alongside the height: collapsed is a true zero, and
    both ends of the motion are seamless.
  */
  function openIt(details, panel) {
    details.open = true;
    if (reduce) return;
    var cs = getComputedStyle(panel);
    var padT = parseFloat(cs.paddingTop) || 0;
    var padB = parseFloat(cs.paddingBottom) || 0;
    panel.style.overflow = 'hidden';
    panel.style.transition = '';
    panel.style.height = 'auto';
    var full = panel.getBoundingClientRect().height;         // content + padding
    var content = Math.max(0, full - padT - padB);           // content-box height
    panel.style.height = '0px';
    panel.style.paddingTop = '0px';
    panel.style.paddingBottom = '0px';
    panel.style.opacity = '0';
    panel.getBoundingClientRect();                            // force reflow
    panel.style.transition = EASE;
    panel.style.height = content + 'px';
    panel.style.paddingTop = padT + 'px';
    panel.style.paddingBottom = padB + 'px';
    panel.style.opacity = '1';
    panel.addEventListener('transitionend', function te(e) {
      if (e.propertyName !== 'height') return;
      clear(panel);
      panel.removeEventListener('transitionend', te);
    });
  }

  function closeIt(details, panel, done) {
    if (reduce) { details.open = false; if (done) done(); return; }
    var cs = getComputedStyle(panel);
    var padT = parseFloat(cs.paddingTop) || 0;
    var padB = parseFloat(cs.paddingBottom) || 0;
    panel.style.overflow = 'hidden';
    panel.style.transition = '';
    panel.style.height = (panel.getBoundingClientRect().height - padT - padB) + 'px';
    panel.style.paddingTop = padT + 'px';
    panel.style.paddingBottom = padB + 'px';
    panel.style.opacity = '1';
    panel.getBoundingClientRect();                            // force reflow
    panel.style.transition = EASE;
    panel.style.height = '0px';
    panel.style.paddingTop = '0px';
    panel.style.paddingBottom = '0px';
    panel.style.opacity = '0';
    panel.addEventListener('transitionend', function te(e) {
      if (e.propertyName !== 'height') return;
      details.open = false; // now the native element hides it cleanly
      clear(panel);
      panel.removeEventListener('transitionend', te);
      if (done) done();
    });
  }

  function bind(details) {
    if (details.dataset.cliktAcc) return;
    var summary = details.querySelector(':scope > summary');
    var panel = panelOf(details);
    if (!summary || !panel) return;
    details.dataset.cliktAcc = '1';
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.dataset.cliktBusy) return;
      details.dataset.cliktBusy = '1';
      var free = function () { delete details.dataset.cliktBusy; };
      if (details.open) {
        closeIt(details, panel, free);
      } else {
        openIt(details, panel);
        setTimeout(free, 440);
      }
    });
  }

  function init() {
    var all = document.querySelectorAll('details');
    for (var i = 0; i < all.length; i++) {
      if (panelOf(all[i])) bind(all[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
